import firebase from "firebase";
import { DateMetadataInterface } from "myfitworld-model/dist/enums/DateMetadata";
import { ModeFormType } from "src/types/other";

export const applyDateMetadata = (mode: ModeFormType, defaultState?: any) => {
    const objectDateMetadata = defaultState?.dateMetadata;
    if (mode === "Create") {
        return getCreateMetadata()
    } else if (mode === "Edit") {
        console.log('edit mode')
        if (objectDateMetadata === undefined) {
            console.log('objectDateMetadata is undefined')
            return getCreateMetadata();
        } else {
            console.log('objectDateMetadata is defined')
            objectDateMetadata.dateModified = new Date();
            return objectDateMetadata;
        }
    }

};

export const getCreateMetadata = ()=>{
    let dateMetadata: DateMetadataInterface = {
        dateCreated: new Date(),
        dateModified: new Date(),
    };
    return dateMetadata;
}

export const formatDateMetadataFromRawData = (rawData:any) => {
  const metadata = {
    ...rawData.dateMetadata,
    dateCreated:
      rawData.dateMetadata?.dateCreated instanceof firebase.firestore.Timestamp
        ? rawData.dateMetadata.dateCreated.toDate()
        : rawData.dateMetadata?.dateCreated,
    dateModified:
      rawData.dateMetadata?.dateModified instanceof firebase.firestore.Timestamp
        ? rawData.dateMetadata.dateModified.toDate()
        : rawData.dateMetadata?.dateModified,
  }
  return metadata;
}

